import { render, staticRenderFns } from "./orders-per-client.vue?vue&type=template&id=5b717dd0"
import script from "./orders-per-client.vue?vue&type=script&lang=js"
export * from "./orders-per-client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports